import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Reply: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.75 20.1153C17.7069 16.6538 16.71 15.2691 12.75 15.2691H10.6731V19.423L3.75 11.8076L10.6731 4.88452V9.03837H12.0577C18.9808 9.03837 20.3654 15.9614 21.75 20.1153Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
